import loadMore from "./loadMore/index";
import loadCascader from "./loadCascader/index";
import tooltipAutoShow from "./tooltipAutoShow/index";
var install = function install(Vue) {
  Vue.directive('loadCascader', loadCascader);
  Vue.directive('loadMore', loadMore);
  Vue.directive('tooltip-auto-show', tooltipAutoShow);
};
export default install;